import {
    ArrowRight,
    CheckCircle2,
    ExternalLink,
    LayoutDashboard,
    Rocket,
    Sparkles
} from "lucide-react";

export default function MobilePreviewReadyCard({
    ownershipMode = "guest",
    projectId = "",
    liveUrl = "",
    isPublished = false,
    saving = false,
    onSave,
    onLogin
}) {
    const isGuest = ownershipMode === "guest";

    const scrollToPreview = () => {
        const preview = document.querySelector(".embedded-preview");
        if (preview) {
            preview.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    return (
        <section className="mpr-card">
            <div className="mpr-orb mpr-orb-one" />
            <div className="mpr-orb mpr-orb-two" />

            <div className="mpr-top">
                <div className="mpr-icon">
                    <Sparkles size={21} />
                </div>

                <div className="mpr-status">
                    <span>Preview Ready</span>
                    <strong>Website + CRM prepared</strong>
                </div>
            </div>

            <div className="mpr-copy">
                <h2>
                    Your AI website is ready to review.
                </h2>

                <p>
                    Your AI website preview is ready. Review it and save it to your CRM workspace when ready.
                </p>
            </div>

            <div className="mpr-proof-grid">
                <div>
                    <CheckCircle2 size={16} />
                    <span>Website preview</span>
                </div>

                <div>
                    <CheckCircle2 size={16} />
                    <span>CRM modules</span>
                </div>

                <div>
                    <CheckCircle2 size={16} />
                    <span>Lead capture</span>
                </div>

                <div>
                    <CheckCircle2 size={16} />
                    <span>Publish ready</span>
                </div>
            </div>

            <div className="mpr-actions">
                {isGuest ? (
                    <>
                        <button
                            type="button"
                            className="mpr-btn primary"
                            disabled={saving}
                            onClick={onSave}
                        >
                            {saving ? "Saving..." : "Save & Open CRM"}
                            <ArrowRight size={17} />
                        </button>

                        <button
                            type="button"
                            className="mpr-btn secondary"
                            onClick={scrollToPreview}
                        >
                            View Preview
                            <ExternalLink size={16} />
                        </button>

                        <button
                            type="button"
                            className="mpr-btn ghost"
                            onClick={onLogin}
                        >
                            Login to Continue
                        </button>
                    </>
                ) : (
                    <>
                        {projectId && (
                            <a
                                className="mpr-btn primary"
                                href={`https://admin.shrianshnexus.in/crm/projects/${projectId}`}
                                target="_blank"
                                rel="noreferrer"
                            >
                                Open in CRM
                                <LayoutDashboard size={17} />
                            </a>
                        )}

                        <button
                            type="button"
                            className="mpr-btn secondary"
                            onClick={scrollToPreview}
                        >
                            View Preview
                            <ExternalLink size={16} />
                        </button>

                        {isPublished && liveUrl ? (
                            <a
                                className="mpr-btn success"
                                href={liveUrl}
                                target="_blank"
                                rel="noreferrer"
                            >
                                View Published Site
                                <Rocket size={17} />
                            </a>
                        ) : (
                            <a
                                className="mpr-btn ghost"
                                href="https://admin.shrianshnexus.in/dashboard"
                                target="_blank"
                                rel="noreferrer"
                            >
                                Continue to Dashboard
                            </a>
                        )}
                    </>
                )}
            </div>
        </section>
    );
}